@for (row of data; track row) {
  <div class="portal-teaser layout-{{row.layout}}">
    <h2 [innerHTML]="row.headline"></h2>
    @if (row.image) {
      <div class="image-wrapper">
        <div class="image">
          <img [src]="row.image" alt="">
          @if (row.copyright) {
            <span class="copyright" [innerHTML]="row.copyright"></span>
          }
        </div>
      </div>
    }
    <div class="content-wrapper" [innerHTML]="row.content"></div>
    @if (row.url && row.buttontext) {
      <div class="cta-wrapper">
        <a role="button" [href]="row.url" class="button primary" target="_blank" [innerHTML]="row.buttontext"></a>
      </div>
    }
  </div>
}
